import create, { SetState, StateCreator, StoreApi } from "zustand";
import { Moment } from "moment";
import { isEmpty } from "lodash";
import { COMPLETE } from "../pages/member-details/care-coordination/constants";
import { isSubTaskDisplayed } from "@pages/member-details/care-coordination/helpers";


interface ICareCoordinationStore {
  dataForCareCoordination: any;
  setDataForCareCoordination: (x: any) => void;
  previousDataForCareCoordination: any;
  setPreviousDataForCareCoordination: (x: any) => void;
  rules: any;
  setRules: (x: any) => void;
  validations : any;
  setValidations : (x: any) => void;
  // globalBarriers: any;
  // setGlobalBarriers: (x: any) => void;
  programOptions: any;
  setProgramOptions: (x: any) => void;
  interventionOptions: any;
  setInterventionOptions: (x: any) => void;
  assignedPrograms: any;
  setAssignedPrograms: (x: any) => void;
  careProgramAssigneeList  : any;
  setCareProgramAssigneeList  : (x: any) => void;
  interventionStartDate: Moment | undefined;
  setInterventionStartDate: (x: any) => void;
  interventionDetailCollapse: string[];
  setInterventionDetailCollapse: (x: any) => void;
  updatedNotes: any;
  setUpdatedNotes: (x: any) => void;
  updatedReminder: any;
  setUpdatedReminder: (x: any) => void;
  driversList: any;
  setDriversList: (x: any) => void;
  isAllComplete: any;
  isTaskValid: (task: any , dependantSubTasks ?: any) => boolean;
  haveMandatorySubTasks: (task: any) => boolean;
  isProgramValid: (intervention: any) => boolean;
  setisAllComplete: (x: any) => void;
  carePlanProgramActive: any;
  setCarePlanProgramActive: (x: any) => void;
  initialResponse: any;
  setInitialResponse: (x: any) => void;
  activeKeyForPhysicianCarePlan: any;
  setActiveKeyForPhysicianCarePlan: (x: any) => void;
  activekeyPhysicianCarePlanCondition : any;
  setActivekeyPhysicianCarePlanCondition : (x: any) => void;
  memberProfilePhysicianCarePlanLoader: boolean;
  setMemberProfilePhysicianCarePlanLoader: (x: boolean) => void;
  activeProgram : any;
  setActiveProgram: (x: any) => void;
  additionalData : any;
  setAdditionalData : (x: any) => void;
  physicianCarePlanNotes : any;
  setPhysicianCarePlanNotes : (x: any) => void;
  clearStore: () => void;
}

const taskValidation: (task: any , dependantSubTasks : any) => any[] = (task , dependantSubTasks) => {
  const subtasks = task?.subtasks || [];
  let errors = subtasks
    .map((st: any) => {
      return st.isMandatory === "Y" && isEmpty(st.value) && isSubTaskDisplayed(st , dependantSubTasks);
    });

  return errors.filter((error: any) => !!error);
};

const isTaskValid: ICareCoordinationStore["isTaskValid"] = (task , dependantSubTasks) => {
  let errors = taskValidation(task , dependantSubTasks);

  return errors.length === 0;
};

let store: StateCreator<ICareCoordinationStore, [], [], ICareCoordinationStore> | StoreApi<ICareCoordinationStore> = (set: SetState<ICareCoordinationStore>) => ({
  rules: [],
  setRules: (x) => {
    set(() => ({ rules: x }));
  },
  validations : [],
  setValidations : (x) => {
    set(() => ({ validations : x }));
  },
  // globalBarriers: [],
  // setGlobalBarriers: (x) => {
  //   set(() => ({ globalBarriers: x }));
  // },
  dataForCareCoordination: [],
  setDataForCareCoordination: (x: any) => {
    set(() => ({ dataForCareCoordination: x }));
  },
  previousDataForCareCoordination: [],
  setPreviousDataForCareCoordination: (x: any) => {
    set(() => ({ previousDataForCareCoordination: x }));
  },
  programOptions: [],
  setProgramOptions: (x) => {
    set(() => ({ programOptions: x }));
  },
  interventionOptions: [],
  setInterventionOptions: (x) => {
    set(() => ({ interventionOptions: x }));
  },
  assignedPrograms: [],
  setAssignedPrograms: (x: any) => {
    set(() => ({ assignedPrograms: x }));
  },
  careProgramAssigneeList  : [],
  setCareProgramAssigneeList  : (x: any) => {
    set(() => ({ careProgramAssigneeList  : x }));
  },
  interventionStartDate: undefined,
  setInterventionStartDate: (x) => {
    set((state) => ({ interventionStartDate: x }));
  },
  interventionDetailCollapse: [],
  setInterventionDetailCollapse: (x) => {
    set((state) => ({ interventionDetailCollapse: x }));
  },
  updatedNotes: { editedNotes: [], deletedNotes: [] },
  setUpdatedNotes: (x) => {
    set((state) => ({ updatedNotes: x }));
  },
  updatedReminder: { editedReminder: [], deletedReminder: [] },
  setUpdatedReminder: (x) => {
    set((state) => ({ updatedReminder: x }));
  },
  driversList: [],
  setDriversList: (x) => {
    set((state) => ({ driversList: x }));
  },
  isAllComplete: "false",
  setisAllComplete: (x) => {
    set((state) => ({ isAllComplete: x }));
  },
  carePlanProgramActive: false,
  setCarePlanProgramActive: (x) => {
    set((state) => ({ carePlanProgramActive: x }));
  },
  initialResponse: {},
  setInitialResponse: (x) => {
    set((state) => ({ initialResponse: x }));
  },
  activeKeyForPhysicianCarePlan: [],
  setActiveKeyForPhysicianCarePlan: (x) => {
    set((state) => ({ activeKeyForPhysicianCarePlan: x}));
  },
  activekeyPhysicianCarePlanCondition : {},
  setActivekeyPhysicianCarePlanCondition : (x) => {
    set((state) => ({ activekeyPhysicianCarePlanCondition: x}));
  },
  isProgramValid: (intervention: any) => {
    let tasks = intervention?.tasks || [];

    const invalidTasks = tasks.map((task: any) => isTaskValid(task) || task.status === COMPLETE).filter((status: boolean) => !status);
    return invalidTasks.length === 0;
  },
  isTaskValid: isTaskValid,
  haveMandatorySubTasks: (task: any) => {
    const mandatoryFields = (task.subtasks || []).filter((st: any) => st.isMandatory === "Y");
    return mandatoryFields.length > 0;
  },

  memberProfilePhysicianCarePlanLoader: false,
  setMemberProfilePhysicianCarePlanLoader: (x) => {
    set((state) => ({ memberProfilePhysicianCarePlanLoader: x }));
  },
  activeProgram: undefined,
  setActiveProgram: (x) => {
    set((state) => ({ activeProgram: x }));
  },
  additionalData: {},
  setAdditionalData: (x) => {
    set((state) => ({ additionalData: x }));
  },
  physicianCarePlanNotes : [],
  setPhysicianCarePlanNotes : (x) => {
    set((state) => ({ physicianCarePlanNotes: x }));
  },
  clearStore: () => {
    set(() => ({ dataForCareCoordination: [] }));
    set(() => ({ previousDataForCareCoordination: [] }));
    set(() => ({ rules: [] }));
    set(() => ({ validations: [] }));
    // set(() => ({ globalBarriers: [] }));
    set(() => ({ programOptions: [] }));
    set(() => ({ interventionOptions: [] }));
    set(() => ({ assignedPrograms: [] }));
    set(() => ({ careProgramAssigneeList : [] }));
    set(() => ({ interventionStartDate: undefined }));
    set(() => ({ updatedNotes: { editedNotes: [], deletedNotes: [] } }));
    set(() => ({ updatedReminder: { editedReminder: [], deletedReminder: [] } }));
    set(() => ({ driversList: [] }));
    set(() => ({ interventionDetailCollapse: [] }));
    set(() => ({ isAllComplete: "false" }));
    set(() => ({ carePlanProgramActive: false }));
    set(() => ({ initialResponse: {} }));
    set(() => ({ activeKeyForPhysicianCarePlan: [] }));
    set(() => ({ memberProfilePhysicianCarePlanLoader: false}));
    set(() => ({ activekeyPhysicianCarePlanCondition: {}}));
    set(() => ({ activeProgram: undefined}));
    set(() => ({ additionalData: {}}));
    set(() => ({ physicianCarePlanNotes : []}));
  },
});

export const useCareCoordinationStore = create(store);
